/**
 * useInterrupt Hook
 * Allows interrupting avatar speech
 */

import { useCallback } from 'react';
import { useStreamingAvatarContext } from '../context/StreamingAvatarContext';

export const useInterrupt = () => {
  const { avatarRef } = useStreamingAvatarContext();

  const interrupt = useCallback(async () => {
    if (!avatarRef.current) return;
    await avatarRef.current.interrupt();
  }, [avatarRef]);

  return { interrupt };
};
